import React, { useMemo } from 'react';
import { RouteComponentProps } from 'react-router';
import { RemoteModule } from '@invent/platform-api';
import { usePlatformWidgetMetaByIdSelector } from '@/src/domains/widgets/selectors';
import { Page404 } from '@/src/components';
import { useWidgetDataGenerator } from '@/lib/module-federation';

export const PlatformWidgetRoute = ({ match }: RouteComponentProps<{ widgetId: string }>) => {
  const { widgetId } = match.params;
  const widgetMeta = usePlatformWidgetMetaByIdSelector(widgetId);
  const widgetDataGenerator = useWidgetDataGenerator();

  const moduleData = useMemo(
    () => widgetMeta && widgetDataGenerator(widgetMeta.name, widgetMeta.widgetId),
    [widgetMeta, widgetDataGenerator]
  );

  if (!moduleData) {
    return <Page404 />;
  }

  return (
    <RemoteModule
      scope={moduleData.scope}
      module={moduleData.component}
      componentProps={widgetMeta?.defaultProps}
      url={moduleData.host}
    />
  );
};
